// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"E4-z","displaySixCardTiles":"F4-z"};